'use strict';
export class LalamoveError extends Error {
    constructor(raw = {}) {
        super(raw.message);
        this.code = raw.message;
        this.message = raw.message;
    }
    static generate(errorData) {
        switch (errorData.message) {
            case 'ERR_DELIVERY_MISMATCH':
                return new DeliveryMismatchError(errorData);
            case 'ERR_INSUFFICIENT_STOPS':
                return new InsufficientStopsError(errorData);
            case 'ERR_TOO_MANY_STOPS':
                return new TooManyStopsError(errorData);
            case 'ERR_INVALID_PAYMENT_METHOD':
                return new InvalidPaymentMethodError(errorData);
            case 'ERR_INVALID_LOCALE':
                return new InvalidLocaleError(errorData);
            case 'ERR_INVALID_MARKET':
                return new InvalidMarketError(errorData);
            case 'ERR_INVALID_PHONE_NUMBER':
                return new InvalidPhoneNumberError(errorData);
            case 'ERR_INVALID_SCHEDULE_TIME':
                return new InvalidScheduleTimeError(errorData);
            case 'ERR_INVALID_SERVICE_TYPE':
                return new InvalidServiceTypeError(errorData);
            case 'ERR_INVALID_SPECIAL_REQUEST':
                return new InvalidSpecialRequestError(errorData);
            case 'ERR_OUT_OF_SERVICE_AREA':
                return new OutOfServiceAreaError(errorData);
            case 'ERR_REVERSE_GEOCODE_FAILURE':
                return new ReverseGeocodeFailureError(errorData);
            case 'ERR_INSUFFICIENT_CREDIT':
                return new InsufficientCreditError(errorData);
            case 'ERR_INVALID_CURRENCY':
                return new InvalidCurrencyError(errorData);
            case 'ERR_PRICE_MISMATCH':
                return new PriceMismatchError(errorData);
            case 'ERR_CANCELLATION_FORBIDDEN':
                return new CancellationForbiddenError(errorData);
            case 'ERR_EXCEED_MIN_TIPS':
                return new ExceedMinTipsError(errorData);
            case 'ERR_EXCEED_MAX_TIPS':
                return new ExceedMaxTipsError(errorData);
            case 'ERR_INVALID_TIPS':
                return new InvalidTipsError(errorData);
            case 'ERR_INVALID_ORDER_STATUS':
                return new InvalidOrderStatusError(errorData);
            default:
                return new Error(errorData.message);
        }
    }
}
class DeliveryMismatchError extends LalamoveError {
}
class InsufficientStopsError extends LalamoveError {
}
class TooManyStopsError extends LalamoveError {
}
class InvalidPaymentMethodError extends LalamoveError {
}
class InvalidLocaleError extends LalamoveError {
}
class InvalidMarketError extends LalamoveError {
}
class InvalidPhoneNumberError extends LalamoveError {
}
class InvalidScheduleTimeError extends LalamoveError {
}
class InvalidServiceTypeError extends LalamoveError {
}
class InvalidSpecialRequestError extends LalamoveError {
}
class OutOfServiceAreaError extends LalamoveError {
}
class ReverseGeocodeFailureError extends LalamoveError {
}
class InsufficientCreditError extends LalamoveError {
}
class InvalidCurrencyError extends LalamoveError {
}
class PriceMismatchError extends LalamoveError {
}
class CancellationForbiddenError extends LalamoveError {
}
class ExceedMinTipsError extends LalamoveError {
}
class ExceedMaxTipsError extends LalamoveError {
}
class InvalidTipsError extends LalamoveError {
}
class InvalidOrderStatusError extends LalamoveError {
}
class ConnectionError extends LalamoveError {
}
class RateLimitError extends LalamoveError {
}
class AuthenticationError extends LalamoveError {
}
class WebhookSignatureVerificationError extends LalamoveError {
}
export { DeliveryMismatchError, InsufficientStopsError, TooManyStopsError, InvalidPaymentMethodError, InvalidLocaleError, InvalidMarketError, InvalidPhoneNumberError, InvalidScheduleTimeError, InvalidServiceTypeError, InvalidSpecialRequestError, OutOfServiceAreaError, ReverseGeocodeFailureError, InsufficientCreditError, InvalidCurrencyError, PriceMismatchError, CancellationForbiddenError, ExceedMinTipsError, ExceedMaxTipsError, InvalidTipsError, InvalidOrderStatusError, ConnectionError, RateLimitError, AuthenticationError, WebhookSignatureVerificationError, };
export const generate = LalamoveError.generate;
//# sourceMappingURL=Errors.js.map